import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { alpha } from "@mui/system";

export default function TypeSelectorSection({ theme, selectedTypes, handleToggle, reportTypes }) {
	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			<Typography
				variant="body2"
				sx={{ color: "text.secondary", fontWeight: 600, mb: 1.5 }}
			>
				Tipos de Relatório
			</Typography>

			<Grid container spacing={2}>
				{reportTypes?.map((type) => {
					const isSelected = selectedTypes.includes(type.id);
					const IconComponent = type.IconComponent;

					return (
						<Grid item xs={12} sm={4} key={type.id}>
							<Box
								onClick={() => handleToggle(type.id)}
								sx={{
									position: "relative",
									border: "1px solid",
									borderColor: isSelected
										? theme.palette.primary.main
										: theme.palette.divider,
									borderRadius: "12px",
									p: 2,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									gap: 1.5,
									cursor: "pointer",
									bgcolor: isSelected
										? alpha(theme.palette.primary.main, 0.05)
										: "transparent",
									transition: "all 0.2s ease",
									"&:hover": {
										borderColor: theme.palette.primary.main,
										bgcolor: alpha(theme.palette.primary.main, 0.02),
									},
								}}
							>
								{isSelected && (
									<CheckCircle
										color="primary"
										sx={{
											position: "absolute",
											top: 12,
											right: 12,
											fontSize: "20px",
										}}
									/>
								)}

								<Box
									sx={{
										backgroundColor: isSelected
											? theme.palette.primary.main
											: alpha(theme.palette.primary.main, 0.2),
										borderRadius: "10px",
										width: "35px",
										height: "35px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										transition: "background-color 0.2s ease",
									}}
								>
									<IconComponent
										fontSize="small"
										sx={{
											color: isSelected
												? theme.palette.primary.contrastText || "#fff"
												: theme.palette.mode === "dark"
													? theme.palette.primary.light
													: theme.palette.primary.dark,
											transition: "color 0.2s ease",
										}}
									/>
								</Box>

								<Typography
									variant="body2"
									sx={{
										fontWeight: isSelected ? 600 : 500,
										color: isSelected ? "primary.main" : "text.primary",
									}}
								>
									{type.label}
								</Typography>
							</Box>
						</Grid>
					);
				})}
			</Grid>
		</Box>
	);
}
